import { OptionalColumnEnum, Style, UsageType } from "../../enums/DRCXEnums";
import { eLynxObjectTypeEnum } from "../../enums/eLynxObjectType";
import { makeOptionalColumnEquatableKey } from "../../utilities/drcx/MakeOptionalColumnEquatableKey";
import { DRCXAvailableObjectBase } from "./DRCXAvailableObjectBase";

export class DRCXAvailableOptionalColumn extends DRCXAvailableObjectBase<string> {
    public constructor(displayText: string,
                       public optionalColumn: OptionalColumnEnum,
                       public key: string = displayText,
                       public usageType: UsageType = UsageType.Allowed,
                       public defaultOrder: number | undefined = undefined,
                       public isUomHidden: boolean | undefined = undefined,
                       public id: number | undefined = undefined,
                        public isAggregationHidden: boolean | undefined = undefined) {
        super(displayText, makeOptionalColumnEquatableKey(optionalColumn, key, id));
    }

    public static getLookupKey(style: Style, dataType: eLynxObjectTypeEnum): string {
        return `${style}:${dataType}`;
    }
}
